import React, { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { Label } from '@nooz-optics/nooz-components-lib';
import { IColor, IInput, ILabel } from 'utils/types/contentful';
import clsx from 'clsx';

export interface SelectProps extends IInput {
  value: any;
  onChange: Function;
}

const returnSelectVariant = (
  type: string,
  color: IColor,
  label: ILabel
): string => {
  const selectColor = color && color.classname;
  const focus = `focus:ring-${selectColor} focus:border-${selectColor}`;
  switch (type) {
    case 'contained':
      return `bg-${selectColor} ${focus} text-${label?.color?.classname}`;
    case 'outlined':
      return `border border-${selectColor} ${focus} text-${label?.color?.classname}`;
    case 'white':
      return `bg-white border border-black ${focus}`;
    default:
      return `bg-white border border-black ${focus}`;
  }
};

export const Select: React.FC<SelectProps> = ({
  label,
  type,
  color,
  values,
  value,
  onChange,
}) => (
  // @ts-ignore
  <Listbox
    value={value}
    onChange={onChange}>
    <div className='relative mt-1 cursor-pointer'>
      {label && (
        <div className='mb-1'>
          <Label {...label} />
        </div>
      )}
      <Listbox.Button
        className={clsx(
          'relative flex justify-between items-center w-full p-2 text-left rounded-md border border-primary focus:outline-none focus-visible:ring-2',
          returnSelectVariant(type, color, label)
        )}>
        <span className='block truncate'>{value?.label?.text}</span>
        <ChevronDownIcon
          className={`w-5 h-5 ml-1 text-${label?.color?.classname}`}
          aria-hidden='true'
        />
      </Listbox.Button>
      <Transition
        as={Fragment}
        leave='transition ease-in duration-100'
        leaveFrom='opacity-100'
        leaveTo='opacity-0'>
        <Listbox.Options
          className={`absolute text-gray-900   py-1 mt-1 overflow-auto no-scrollbar text-base bg-white rounded-md border border-${color?.classname} shadow-lg z-40 focus:outline-none sm:text-sm`}>
          {values &&
            values.map((val) => (
              <Listbox.Option
                className={({ active }) =>
                  clsx(
                    { 'bg-gray-200': active },
                    'transition cursor-pointer duration-100 select-none relative py-2 px-4'
                  )
                }
                value={val.value}>
                {({ selected }) => (
                  <Label
                    type='span'
                    text={val.label?.text}
                    truncate
                    color={color}
                    weight={selected ? 'medium' : 'normal'}
                    icon={selected && { iconKey: 'HiOutlineCheck' }}
                  />
                )}
              </Listbox.Option>
            ))}
        </Listbox.Options>
      </Transition>
    </div>
  </Listbox>
);
